import * as React from 'react';
import { ConfigContext } from '../config-provider';
import classNames from 'classnames';
import useBuriedPoint from '../_util/hooks/useBuriedPoint';
const Segmented = React.forwardRef((props) => {
    useBuriedPoint('Segmented');
    const { style, prefixCls: customizePrefixCls, className: customizeClassName, options = [], } = props;
    const { getPrefixCls, direction } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('segmented', customizePrefixCls);
    const className = classNames(prefixCls, customizeClassName, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-block`]: props.block,
        [`${prefixCls}-lg`]: props.size === 'large',
        [`${prefixCls}-sm`]: props.size === 'small',
    });
    const getOptionsValue = (item) => {
        return typeof item === 'object' ? item.value : item;
    };
    const [activekey, setActivekey] = React.useState(props.value || getOptionsValue(options[0]));
    const random = Math.random().toString(36).slice(-6);
    const thumbRef = React.useRef();
    const onChange = (e, item) => {
        e.preventDefault();
        const value = getOptionsValue(item);
        if ((item === null || item === void 0 ? void 0 : item.disabled) || activekey === value)
            return;
        addTranslate(activekey, value);
        setTimeout(() => {
            var _a;
            setActivekey(value);
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, value, item);
        }, 150);
    };
    const addTranslate = (oldKey, newKey) => {
        var _a;
        const oldActiveDom = document.getElementById(`${prefixCls}-item-${oldKey}-${random}`);
        const newActiveDom = document.getElementById(`${prefixCls}-item-${newKey}-${random}`);
        if (oldActiveDom && newActiveDom) {
            const { offsetWidth: oldOffsetWidth, offsetLeft: oldOffsetLeft } = oldActiveDom;
            const { offsetWidth, offsetLeft } = newActiveDom;
            (_a = thumbRef.current) === null || _a === void 0 ? void 0 : _a.animate([
                {
                    left: oldOffsetLeft + 'px',
                    width: oldOffsetWidth + 'px',
                    opacticy: 1,
                },
                {
                    left: offsetLeft + 'px',
                    width: offsetWidth + 'px',
                    opacticy: 0,
                },
            ], {
                duration: 200,
            });
        }
    };
    return (React.createElement("div", { className: className, style: style },
        React.createElement("div", { className: `${prefixCls}-group` },
            React.createElement("div", { ref: thumbRef, className: classNames([`${prefixCls}-thumb`]) }),
            options.map((item, index) => {
                var _a;
                return (React.createElement("label", { id: `${prefixCls}-item-${getOptionsValue(item)}-${random}`, key: 'segmented_item_' + index, className: classNames({
                        [`${prefixCls}-item`]: true,
                        [`${prefixCls}-item-selected`]: getOptionsValue(item) === activekey,
                        [`${prefixCls}-item-disabled`]: item === null || item === void 0 ? void 0 : item.disabled,
                    }), onClick: (e) => onChange(e, item) },
                    React.createElement("input", { className: `${prefixCls}-item-input` }),
                    React.createElement("div", { className: `${prefixCls}-item-label` }, ((_a = props.label) === null || _a === void 0 ? void 0 : _a.call(props, item)) || item.title || getOptionsValue(item))));
            }))));
});
if (process.env.NODE_ENV !== 'production') {
    Segmented.displayName = 'Segmented';
}
export default Segmented;
